import script from "./AdminStatisticsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminStatisticsPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminStatisticsPage.vue?vue&type=style&index=0&id=045c5bfb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-045c5bfb"]])

export default __exports__